import { default as Utils } from '../utils/base.Utils.js';
export default class UtilsDevices {
  constructor() {

  }

  static getPOIDevicesList(poi, devices) {
    if(poi.Metadata && Array.isArray(devices)) {
        return devices.filter((device) => {
            return Utils.Metadata.getMetadataValuesByID(poi.Metadata, device.name) == 'true';
        });
    } else return [];
  }

}
